"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FlagAt_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagAt"));
const FlagBe_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagBe"));
const FlagCh_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagCh"));
const FlagDe_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagDe"));
const FlagDn_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagDn"));
const FlagEs_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagEs"));
const FlagFr_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagFr"));
const FlagIt_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagIt"));
const FlagLux_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagLux"));
const FlagNl_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagNl"));
const FlagPl_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagPl"));
const FlagUk_1 = __importDefault(require("@kawaui/icons/build/icons/flags/FlagUk"));
const react_1 = require("react");
const styles_1 = require("./styles");
const COUNTRY_CODE_MAPPING = {
    AT: FlagAt_1.default,
    BE: FlagBe_1.default,
    CH: FlagCh_1.default,
    DE: FlagDe_1.default,
    DN: FlagDn_1.default,
    ES: FlagEs_1.default,
    ESMX: FlagEs_1.default,
    FR: FlagFr_1.default,
    IT: FlagIt_1.default,
    ITCH: FlagIt_1.default,
    NL: FlagNl_1.default,
    PL: FlagPl_1.default,
    UK: FlagUk_1.default,
    LU: FlagLux_1.default,
};
const CountryList = ({ countryMainList, selectedCountry }) => {
    const options = (0, react_1.useMemo)(() => {
        if (!countryMainList)
            return [];
        return countryMainList.reduce((countries, { countriesList }) => {
            if (!countriesList)
                return countries;
            return countries.concat(countriesList.map(({ countryCode, flagText, flagUrl }) => ({
                icon: countryCode ? COUNTRY_CODE_MAPPING[countryCode] : null,
                params: { countryCode, flagUrl },
                value: flagText !== null && flagText !== void 0 ? flagText : '',
            })));
        }, []);
    }, [countryMainList]);
    const selectedOption = (0, react_1.useMemo)(() => options.find((option) => { var _a; return ((_a = option.params) === null || _a === void 0 ? void 0 : _a.countryCode) === selectedCountry; }), [options, selectedCountry]);
    const [selected, setSelected] = (0, react_1.useState)(selectedOption);
    (0, react_1.useEffect)(() => {
        setSelected(selectedOption);
    }, [selectedOption]);
    const handleChange = (0, react_1.useCallback)((option) => {
        var _a;
        setSelected(option);
        if ((_a = option.params) === null || _a === void 0 ? void 0 : _a.flagUrl)
            window.location.href = option.params.flagUrl;
    }, []);
    return ((0, jsx_runtime_1.jsx)(styles_1.DropdownContainer, { children: (0, jsx_runtime_1.jsx)(styles_1.CustomDropdown, { icon: (selected === null || selected === void 0 ? void 0 : selected.icon) || undefined, onChange: handleChange, placement: "top", value: selected === null || selected === void 0 ? void 0 : selected.value, isFullWidth: true, options: options, disablePortal: true }) }));
};
exports.CountryList = CountryList;
exports.default = exports.CountryList;
